import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LogisticaService } from '../services/logistica.service';
import { showSpinner, hideSpinner } from 'src/app/core/services/functions.service';
import { NotificationHelper } from 'src/app/core/services/helpers/notification.helper';

@Component({
  selector: 'app-modal-historico-alertas',
  templateUrl: './modal-historico-alertas.component.html',
  styleUrls: ['./modal-historico-alertas.component.scss']
})
export class ModalHistoricoAlertasComponent implements OnInit {
  historico: any[] = [];
  displayedColumns: string[] = ['FECHA_EVENTO', 'USUARIO_EVENTO', 'ACCION', 'PORC_AVANCE', 'ASUNTO', 'DESTINATARIOS', 'ESTADO'];

  constructor(
    public dialogRef: MatDialogRef<ModalHistoricoAlertasComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private logisticaService: LogisticaService,
    private notificationService: NotificationHelper
  ) {}

  async ngOnInit() {
    await this.cargarHistorico();
  }

  async cargarHistorico() {
    try {
      showSpinner();
      const response = await this.logisticaService.obtenerHistorialAlertas(this.data.idCapacidad);
      
      if (response && response.status === 'success') {
        this.historico = response.data || [];
      } else {
        this.notificationService.infoMessage("No hay histórico para esta capacidad");
      }
    } catch (error) {
      console.error('Error al cargar histórico:', error);
      this.notificationService.errorMessage("Error al cargar el histórico");
    } finally {
      hideSpinner();
    }
  }

  cerrar() {
    this.dialogRef.close();
  }
}
